import { withT } from "neetocommons/react-utils";
import { Copy, Delete } from "neetoicons";
import { Button } from "neetoui";

const OptionActions = withT(
  ({
    t,
    disabled,
    hideCloneOption = false,
    hideDeleteOption = false,
    optionIndex,
    id,
    arrayHelpers,
    onClone,
    onDelete,
    className = "",
  }) => (
    <div className={`flex items-center gap-1 ${className}`}>
      {!hideCloneOption && (
        <Button
          {...{ disabled }}
          className="p-0.5"
          data-testid={`clone-option-button-${optionIndex}`}
          icon={Copy}
          size="small"
          style="text"
          tooltipProps={{
            content: t("neetoMolecules.common.actions.clone"),
            position: "top",
            touch: ["hold", 500],
          }}
          onClick={() => onClone(id)}
        />
      )}
      {!hideDeleteOption && (
        <Button
          {...{ disabled }}
          className="p-0.5"
          data-testid={`delete-option-button-${optionIndex}`}
          icon={Delete}
          size="small"
          style="text"
          tooltipProps={{
            content: t("neetoMolecules.common.actions.delete"),
            position: "top",
            touch: ["hold", 500],
          }}
          onClick={() => onDelete(id, arrayHelpers)}
        />
      )}
    </div>
  )
);

export default OptionActions;
